import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { usePageSeo } from "@/hooks/usePageSeo";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/common/PageHero";
import { EducationCard } from "@/components/common/EducationCard";
import { CTASection } from "@/components/common/CTASection";

const CATS = ["Beginner", "Forex", "Technical Analysis", "Fundamental Analysis", "Risk Management", "Trading Psychology", "Platforms", "Trading Strategies"];

export default function Education() {
  const { L } = useLang();
  const P = L.pages.education;
  usePageSeo("education");
  const { data: lessons = [] } = useQuery({ queryKey: ["education"], queryFn: async () => (await api.get("/education")).data });

  return (
    <>
      <PageHero
        overline={P.overline}
        title={P.title}
        description={P.desc}
        breadcrumbs={[{ label: L.common.home, to: "/" }, { label: L.nav.sub.education[0] }]}
      />

      <section className="py-16 lg:py-24">
        <div className="container-tight">
          {CATS.map((cat) => {
            const group = lessons.filter((l) => l.category === cat);
            if (!group.length) return null;
            return (
              <div key={cat} className="mb-14">
                <h2 className="mb-6 font-heading text-2xl font-semibold text-ink">{cat}</h2>
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                  {group.map((l) => <EducationCard key={l.id} lesson={l} />)}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <CTASection />
    </>
  );
}
